import {Area, AreaChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import Box from "@mui/material/Box";
import * as React from "react";

interface DoubleAreaChartProps {
    height: number;
    data: any;
    color1: string;
    color2: string;
}
export default (props) => {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            height: 160,
        }}>
            <ResponsiveContainer>
                <AreaChart style={{fontSize: '.85rem'}} data={props.data}
                           margin={{top: 10, right: 10, left: 0, bottom: 0}}>
                    <defs>
                        <linearGradient id="success" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor={props.color1}
                                  stopOpacity={0.8}/>
                            <stop offset="95%" stopColor={props.color1} stopOpacity={0}/>
                        </linearGradient>
                        <linearGradient id="failure" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor={props.color2} stopOpacity={0.8}/>
                            <stop offset="95%" stopColor={props.color2} stopOpacity={0}/>
                        </linearGradient>
                    </defs>
                    <XAxis dataKey="day"/>
                    <YAxis width={40}/>
                    <CartesianGrid strokeDasharray="3 3"/>
                    <Tooltip wrapperStyle={{outline: 'none', fontSize: '.95rem'}}
                             labelStyle={{fontSize: '.85rem'}}/>
                    <Legend
                        verticalAlign="bottom"
                        wrapperStyle={{fontSize: '.85rem', bottom: '-10px'}}/>
                    <Area type="monotone" dataKey="Success" stroke={props.color1}
                          fillOpacity={1}
                          fill="url(#success)"/>
                    <Area type="monotone" dataKey="Failure" stroke={props.color2}
                          fillOpacity={1}
                          fill="url(#failure)"/>
                </AreaChart>
            </ResponsiveContainer>
        </Box>
    )
}